<template>
  <lf-date-picker
    v-model="datesArray"
    class="date-filter h-6-5"
    :formatter="defaultDateFormatter"
    :date-placeholder="placeholder"
    hide-second-month
    @update:model-value="dateValue = $event"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useRouteQuery } from "@vueuse/router";
import { defaultDateFormatter } from "@/helpers/constants/dateTime";
import LfDatePicker from "@/components/ui/inputs/LfDatePicker.vue";
const props = withDefaults(
  defineProps<{
    queryKey?: string;
    placeholder: string;
  }>(),
  {
    queryKey: "task_due_date"
  }
);
const dateValue = useRouteQuery(props.queryKey);

const datesArray = computed(() => {
  if (!dateValue.value?.length) {
    return [];
  }
  if (Array.isArray(dateValue.value)) {
    return dateValue.value.map((date) => String(date));
  }
  return [String(dateValue.value)];
});
</script>

<style scoped>
.date-filter :deep() {
  #litepie {
    & > button {
      @apply h-6-5 border-grey-hover bg-grey-hover py-0 pl-2 leading-[24px] text-headline;
    }
    & > div {
      @apply -left-15 bottom-0 scale-[0.8] transform;
    }
    & .top-3-4 {
      @apply right-1-5 top-1-5 scale-[0.75] transform;
    }
  }
}
</style>
